import React, {useEffect, useState} from "react";
import './MobileAlertRulesThresholdsList.scss'
import {ReactComponent as EditIcon} from "../../../assets/icons/editPenIcon.svg";
import {useSelector} from "react-redux";
import ThresholdModal from "../ThresholdModal";

const selector = state => {
    const {language, alertRules, modalState} = state;
    return {
        t: language.translator,
        pending: alertRules.pending,
        alertRules: alertRules.alertRules,
        selected: alertRules.selected,
        alertMessages: alertRules.alertMessages,
        modalState: modalState
    }
};
const MobileAlertRulesThresholdsList = props => {
    const {t} = useSelector(selector)
    const {item} = props;

    const [selectedThreshold, setSelectedThreshold] = useState(null)
    const [selectedWarningType, setSelectedWarningType] = useState(null)
    const [warningEnum, setWarningEnum] = useState(null)
    const [mobileThresholdModal, setMobileThresholdModal] = useState(false)

    const editMethod =  (item, warning, warningEnum) => {
        setSelectedThreshold(null)
        if(item) {
            setSelectedThreshold(item)
        }
        setSelectedWarningType(warning)
        setWarningEnum(warningEnum)
        setMobileThresholdModal(true)
    }

    return (
        <>
            <table className={"MobileAlertRulesThresholdsTable"}>
                <thead>
                <tr>
                    <th colSpan="4">{t.gettext('Values')}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="col-1" rowSpan="2">{t.gettext('Lower threshold')}</td>
                    <td className="col-2"><span className="red">{t.gettext('Critical Alert')}</span></td>
                    <td className="col-3 red">  {
                        item?.thresholds?.find(el => el.warningType === 'ALARM_LOW')?.value === 0
                            ? 0
                            : item?.thresholds?.find(el => el.warningType === 'ALARM_LOW')?.value.toFixed(1) || '-'
                    }</td>
                    <td className="col-4 icon"> {item.editable && (
                        <EditIcon
                            onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'ALARM_LOW'), t.gettext('Alarm Low'), 'ALARM_LOW')}
                        />
                    )}</td>
                </tr>
                <tr>
                    <td className="col-2"><span className="orange">{t.gettext('Standard Alert')}</span></td>
                    <td className="col-3 orange">     {
                        item?.thresholds?.find(el => el.warningType === 'WARNING_LOW')?.value === 0
                            ? 0
                            : item?.thresholds?.find(el => el.warningType === 'WARNING_LOW')?.value.toFixed(1) || '-'
                    }</td>
                    <td className="col-4 icon">  {item.editable && (
                        <EditIcon
                            onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'WARNING_LOW'), t.gettext('Warning Low'), 'WARNING_LOW')}
                        />
                    )}</td>
                </tr>
                <tr>
                    <td className="col-1" rowSpan="2">{t.gettext('Upper threshold')}</td>
                    <td className="col-2"><span className="orange">{t.gettext('Standard Alert')}</span></td>
                    <td className="col-3 orange">     {
                        item?.thresholds?.find(el => el.warningType === 'WARNING_HIGH')?.value === 0
                            ? 0
                            : item?.thresholds?.find(el => el.warningType === 'WARNING_HIGH')?.value.toFixed(1) || '-'
                    }</td>
                    <td className="col-4 icon">       {item.editable && (
                        <EditIcon
                            onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'WARNING_HIGH'), t.gettext('Warning High'), 'WARNING_HIGH')}
                        />
                    )}</td>
                </tr>
                <tr>
                    <td className="col-2"><span className="red">{t.gettext('Critical Alert')}</span></td>
                    <td className="col-3 red">   {
                        item?.thresholds?.find(el => el.warningType === 'ALARM_HIGH')?.value === 0
                            ? 0
                            : item?.thresholds?.find(el => el.warningType === 'ALARM_HIGH')?.value.toFixed(1) || '-'
                    }</td>
                    <td className="col-4 icon">     {item.editable && (
                        <EditIcon
                            onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'ALARM_HIGH'), t.gettext('Alarm High'), 'ALARM_HIGH')}
                        />
                    )}</td>
                </tr>
                </tbody>
            </table>
            {mobileThresholdModal && (
                <ThresholdModal
                    responsive
                    closeMethod={() => setMobileThresholdModal(false)}
                    threshold={selectedThreshold}
                    warningType={selectedWarningType}
                    warningEnum={warningEnum}
                />
            )}

        </>
    )
}

export default MobileAlertRulesThresholdsList;
